import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import colors from '../../../theme/colors';

export type ErrorLabelProps = {
  children?: React.ReactNode;
};

const useStyles = makeStyles({
  errorText: {
    color: colors.bright_pink,
  },
});

const ErrorLabel = ({ children }: ErrorLabelProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Typography variant="caption" className={classes.errorText}>
      {children}
    </Typography>
  );
};

export default ErrorLabel;
